import { createAsyncThunk, createReducer } from '@reduxjs/toolkit';
import { DataLoader, withData as loader } from '@ott/utility-loader';
import superagent from '@ott/superagent';
import { lang } from '@ott/l10n';

import { DEFAULT_HAPI_BASE_URL } from '../../constants';
import prepareResponse from '../utilities/prepareResponse';

import { Destination } from '../../types';

const initialState: DataLoader<Destination[]> = loader.initial();

interface ActionParams {
  hapi?: string;
}

export const fetchPopularDestinations = createAsyncThunk<Destination[], ActionParams>(
  'popularDestinations/fetch',
  async ({ hapi }) => {
    const url = `${hapi || DEFAULT_HAPI_BASE_URL}/topDestinations`;

    try {
      const { body } = await superagent.get(url).query({ limit: 20, lang }).withCredentials();

      return prepareResponse(body?.result || []);
    } catch (error) {
      return Promise.reject();
    }
  }
);

const popularDestinationsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(fetchPopularDestinations.pending, () => loader.begin())
    .addCase(fetchPopularDestinations.fulfilled, (state, { payload }) => loader.success(payload))
    .addCase(fetchPopularDestinations.rejected, () => loader.error());
});

export default popularDestinationsReducer;

export const actions = {
  fetch: fetchPopularDestinations,
};
